import React from "react";
import { Ring } from "react-konva";

import { StatsProps } from "./types";
import * as Config from "./configuration";
import { validCoordinate } from "./utils";

const INNER_RADIUS = 3;
const OUTER_RADIUS = 6;
const STOKE_WIDTH = 1;

const getColor = (result: boolean) => {
  return result ? Config.COLOR_WIN : Config.COLOR_LOSE;
};

export const StatsInterception = ({ from, result }: StatsProps) => {
  if (!validCoordinate(from)) {
    return null;
  }
  return (
    <Ring
      x={from.x}
      y={from.y}
      innerRadius={INNER_RADIUS}
      outerRadius={OUTER_RADIUS}
      fill={getColor(result)}
      stroke="black"
      strokeWidth={STOKE_WIDTH}
    />
  );
};
